<div class="modulo modulo-eventos">
      <div class="modulo-header">
            <div class="container">
                  <div class="content-title">
                        <div class="box">
                              <h1 [innerHtml]="data.titulo"></h1>
                              <h2 [innerHtml]="data.subtitulo"></h2>
                        </div>
                        <div class="box box-form">
                              <form class="form form-custom">
                                    <label>Buscar evento</label>
                                    <div class="content-input">
                                          <input type="text" [(ngModel)]="dataItem.nome" name="nome" placeholder="Digite o nome do evento" (input)="search($event)" />
                                    </div>
                              </form>
                        </div>
                  </div>
            </div>
      </div>
      <div class="modulo-content">
            <div class="container">
                  <div class="evento-lista">
                        <div class="row">
                              <div class="col-md-4" *ngFor="let e of eventos">
                                    <evento-item [data]="e"></evento-item>
                              </div>
                        </div>      
                  </div>
            </div>
      </div>
</div>
